import React, { useEffect, useState, useRef, useMemo } from 'react';
import { Button, TextField, Container, Typography, Box, MenuItem, FormControlLabel, Checkbox, 
  Select, Grid, CircularProgress } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import Header from './Header';
import { useImmerReducer } from 'use-immer'; // Import useImmerReducer if you're using immer
import Cookies from "js-cookie";
import api from '../utils/axiosInstance';
import { useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";

function ListingUpdate(props) {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const apiUrl = process.env.REACT_APP_API_URL;

  const initialState = {
    titleValue: props.listingData.title,
    descriptionValue: props.listingData.description,
    listingTypeValue: props.listingData.listing_type,
    propertyStatusValue: props.listingData.property_status,
    rentalFrequencyValue: props.listingData.rental_frequency,
    priceValue: props.listingData.price,
    roomsValue: props.listingData.rooms,
    furnishedValue: props.listingData.furnished,
    poolValue: props.listingData.pool,
    elevatorValue: props.listingData.elevator,
    parkingValue: props.listingData.parking,
    cctvValue: props.listingData.cctv,
    sendRequest: 0,
  };

  function ReducerFunction(draft, action) {
    switch (action.type) {
      case "catchTitleChange":
        draft.titleValue = action.titleChosen;
        break;
      case "catchDescriptionChange":
        draft.descriptionValue = action.descriptionChosen;
        break;
      case "catchListingTypeChange":
        draft.listingTypeValue = action.listingTypeChosen;
        break;
      case "catchPropertyStatusChange":
        draft.propertyStatusValue = action.propertyStatusChosen;
        break;
      case "catchRentalFrequencyChange":
        draft.rentalFrequencyValue = action.rentalFrequencyChosen;
        break;
      case "catchPriceValueChange":
        draft.priceValue = action.priceChosen;
        break;
      case "catchRoomsValueChange":
        draft.roomsValue = action.roomsChosen;
        break;
      case "catchFurnishedChange":
        draft.furnishedValue = action.furnishedChosen;
        break;
      case "catchPoolChange":
        draft.poolValue = action.poolChosen;
        break;
      case "catchElevatorChange":
        draft.elevatorValue = action.elevatorChosen;
        break;
      case "catchParkingChange":
        draft.parkingValue = action.parkingChosen;
        break;
      case "catchCctvChange":
        draft.cctvValue = action.cctvChosen;
        break;
      case "changeSendRequest":
        draft.sendRequest = draft.sendRequest + 1;
        break;
      default:
        break;
    }
  }

  const [state, dispatch] = useImmerReducer(ReducerFunction, initialState);

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Handle form submission logic
    console.log(state); // Test output
    dispatch({type: 'changeSendRequest'});
  };

  useEffect(() => {
    if (state.sendRequest) {
      async function UpdateProperty() {
        const formData = new FormData();
        const userCookie = Cookies.get('user');  
        const userId = userCookie ? JSON.parse(userCookie).user_id : null;
  
        if (!userId) {
          console.error("User ID not found in cookies");
          toast.error("User not authenticated. Please log in.");
          return;
        }
  
        // Append form data fields based on listing type
        formData.append("title", state.titleValue);
        formData.append("description", state.descriptionValue);
        formData.append("listing_type", state.listingTypeValue);
        formData.append("property_status", state.propertyStatusValue);
        formData.append("rental_frequency", state.rentalFrequencyValue);
        formData.append("price", state.priceValue);
        formData.append("furnished", state.furnishedValue);
        formData.append("pool", state.poolValue);
        formData.append("elevator", state.elevatorValue);
        formData.append("parking", state.parkingValue);
        formData.append("cctv", state.cctvValue);
        formData.append("seller", userId);
  
        if (state.listingTypeValue === "Office") {
          formData.append("rooms", 0);
        } else {
          formData.append("rooms", state.roomsValue);
        }
  
        try {
          const response = await api.patch(
            `${apiUrl}/api/listing/${props.listingData.id}/update/`, 
            formData,
            { headers: { 'Content-Type': 'multipart/form-data' } }
          );
  
          // Success message
          if (response.status === 200) {
            toast.success("Property updated successfully.");
            navigate(0); // Reload page to reflect the update
          }
        } catch (e) {
          setIsLoading(false);
  
          // Handle different error responses with specific toast messages
          if (e.response && e.response.status === 400) {
            console.error("Validation error:", e.response.data);
            toast.error("Validation error. Please check your input.");
  
            const errorData = e.response.data;
            for (let field in errorData) {
              if (errorData[field]) {
                toast.error(`${field}: ${errorData[field].join(', ')}`);
              }
            }
          } else if (e.response && e.response.status === 401) {
            console.error("Unauthorized:", e.response.data);
            toast.error("Unauthorized access. Please log in again.");
          } else if (e.response && e.response.status === 429) {
            console.error("Rate limit exceeded:", e.response.data);
            toast.error("Too many requests. Please try again later.");
          } else {
            console.error("An unexpected error occurred:", e.message);
            toast.error("An unexpected error occurred. Please try again.");
          }
        }
      }
  
      UpdateProperty();
    }
  }, [state.sendRequest]);
  
  // worked perfectly just that i added toast messages above
  // useEffect(() => {
  //   // const source = Axios.CancelToken.source();
  //   if (state.sendRequest) {
  //     async function UpdateProperty() {
  //       const formData = new FormData();
  //       // Get userId from cookies using js-cookie
  //       const userCookie = Cookies.get('user');  // Ensure the cookie exists
  //       const userId = userCookie ? JSON.parse(userCookie).user_id : null;
  //       console.log(userId)

  //       // // Ensure that userId is defined before proceeding
  //       // if (!userId) {
  //       //   console.error("User ID not found in cookies");
  //       //   return;
  //       // }

  //       if (state.listingTypeValue === "Office"){
  //           // Append each form data correctly with two arguments
  //           formData.append("title", state.titleValue);
  //           formData.append("description", state.descriptionValue);
  //           formData.append("listing_type", state.listingTypeValue);
  //           formData.append("property_status", state.propertyStatusValue);
  //           formData.append("rental_frequency", state.rentalFrequencyValue);
  //           formData.append("price", state.priceValue);
  //           formData.append("rooms", 0);
  //           formData.append("furnished", state.furnishedValue);
  //           formData.append("pool", state.poolValue);
  //           formData.append("elevator", state.elevatorValue);
  //           formData.append("parking", state.parkingValue);
  //           formData.append("cctv", state.cctvValue);
  //           formData.append("seller", userId);
  //       }
  //       else {
  //           formData.append("title", state.titleValue);
  //           formData.append("description", state.descriptionValue);
  //           formData.append("listing_type", state.listingTypeValue);
  //           formData.append("property_status", state.propertyStatusValue);
  //           formData.append("rental_frequency", state.rentalFrequencyValue);
  //           formData.append("price", state.priceValue);
  //           formData.append("rooms", state.roomsValue);
  //           formData.append("furnished", state.furnishedValue);
  //           formData.append("pool", state.poolValue);
  //           formData.append("elevator", state.elevatorValue);
  //           formData.append("parking", state.parkingValue);
  //           formData.append("cctv", state.cctvValue);
  //           formData.append("seller", userId);
  //       }

  //       try {
  //         const response = await api.patch(
  //           `http://localhost:8000/api/listing/${props.listingData.id}/update/`, 
  //           formData
  //           // {
  //           //   cancelToken: source.token
  //           // }
  //         );
  //         console.log(response.data);
  //         navigate(0);
  //       } catch (e) {
  //         console.log(e.response);
  //       }
  //     }
  //     UpdateProperty();
  //   }
  // }, [state.sendRequest]);
  
  function priceDisplay() {
    if (state.propertyStatusValue === "Rent" && state.rentalFrequencyValue === "Day") {
      return "Price Per Day";
    }
    else if (state.propertyStatusValue === "Rent" && state.rentalFrequencyValue === "Weekly") {
      return "Price Per Week";
    }
    else if (state.propertyStatusValue === "Rent" && state.rentalFrequencyValue === "Month") {
      return "Price Per Month";
    }
    else if (state.propertyStatusValue === "Rent" && state.rentalFrequencyValue === "Year") {
      return "Price Per Year";
    }
    else {
      return "Price";
    }
  }

//   useEffect(() => {
//     const userCookie = Cookies.get('user');
//     if (userCookie) {
//       const user = JSON.parse(userCookie);
//       // console.log('User Cookie:', user);
      
//       if (user.profile) {
//         console.log('Profile found:', user.profile);
//         dispatch({ type: 'catchUserProfileInfo', profileObject: user.profile });
//         dispatch({ type: 'setUserLoggedIn', payload: true });
//       } else {
//         console.warn("Profile data is not available in user cookie.");
//         dispatch({ type: 'setUserLoggedIn', payload: true });
//       }
//     } else {
//       console.warn("User cookie is not found.");
//       dispatch({ type: 'setUserLoggedIn', payload: false });
//     }
//   }, [dispatch]);  

  if (isLoading) {
    return (
      <div style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <CircularProgress />
      </div>
    );
  }

  return (
    <>
      {/* <Header /> */}
      <Box display="flex" justifyContent="center" alignItems="center" mt={1.5} mb={1}>
        {/* <HomeIcon fontSize="large" /> */}
        <Typography variant="h4" ml={1}>
          Update Listing
        </Typography>
      </Box>
      <Container maxWidth="sm">
        <form onSubmit={handleSubmit}>
          {/* Title Field */}
          <TextField
            label="Title"
            value={state.titleValue}
            onChange={(e) =>
              dispatch({
                type: "catchTitleChange",
                titleChosen: e.target.value,
              })
            }
            variant="outlined"
            margin="normal"
            fullWidth
            required
          />
          {/* Description Field */}
          <TextField
            label="Description"
            value={state.descriptionValue}
            onChange={(e) =>
              dispatch({
                type: "catchDescriptionChange",
                descriptionChosen: e.target.value,
              })
            }
            variant="outlined"
            margin="normal"
            fullWidth
            multiline
            rows={4}
            required
          />

          {/* Listing Type Dropdown */}
          <TextField
            select
            label="Listing Type"
            value={state.listingTypeValue}
            onChange={(e) =>
              dispatch({
                type: "catchListingTypeChange",
                listingTypeChosen: e.target.value,
              })
            }
            variant="outlined"
            margin="normal"
            fullWidth
            required
          >
            {[
              { value: 'House', label: 'House' },
              { value: 'Office', label: 'Office' },
              { value: 'Apartment', label: 'Apartment' }
            ].map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>

          {/* Property Status Dropdown */}
          <TextField
            select
            label="Property Status"
            value={state.propertyStatusValue}
            onChange={(e) =>
              dispatch({
                type: "catchPropertyStatusChange",
                propertyStatusChosen: e.target.value,
              })
            }
            variant="outlined"
            margin="normal"
            fullWidth
            required
          >
            {[
              { value: 'Sale', label: 'Sale' },
              { value: 'Rent', label: 'Rent' }
            ].map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>

          {/* Rental Frequency Dropdown */}
          <TextField
            select
            label="Rental Frequency"
            value={state.rentalFrequencyValue}
            onChange={(e) =>
              dispatch({
                type: "catchRentalFrequencyChange",
                rentalFrequencyChosen: e.target.value,
              })
            }
            variant="outlined"
            disabled={state.propertyStatusValue === 'Sale' ? true : false}
            margin="normal"
            fullWidth
          >
            {[
              { value: 'Day', label: 'Day' },
              { value: 'Weekly', label: 'Weekly' },
              { value: 'Month', label: 'Month' },
              { value: 'Year', label: 'Year' }
            ].map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>

          {/* Price Field */}
          <TextField
            label={priceDisplay()}
            type="number"
            value={state.priceValue}
            onChange={(e) =>
              dispatch({
                type: "catchPriceValueChange",
                priceChosen: e.target.value,
              })
            }
            variant="outlined"
            margin="normal"
            fullWidth
            required
          />

          {/* Rooms Field */}
          {state.listingTypeValue === "Office" ? (
            ""
          ) : (
            <TextField
            label="Rooms"
            type="number"
            value={state.roomsValue}
            onChange={(e) =>
              dispatch({
                type: "catchRoomsValueChange",
                roomsChosen: e.target.value,
              })
            }
            variant="outlined"
            margin="normal"
            fullWidth
            required
          />
          )}

          {/* Checkboxes for Booleans */}
          <FormControlLabel
            control={
              <Checkbox
                checked={state.furnishedValue}
                onChange={(e) =>
                  dispatch({
                    type: "catchFurnishedChange",
                    furnishedChosen: e.target.checked,
                  })
                }
              />
            }
            label="Furnished"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={state.poolValue}
                onChange={(e) =>
                  dispatch({
                    type: "catchPoolChange",
                    poolChosen: e.target.checked,
                  })
                }
              />
            }
            label="Pool"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={state.elevatorValue}
                onChange={(e) =>
                  dispatch({
                    type: "catchElevatorChange",
                    elevatorChosen: e.target.checked,
                  })
                }
              />
            }
            label="Elevator"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={state.parkingValue}
                onChange={(e) =>
                  dispatch({
                    type: "catchParkingChange",
                    parkingChosen: e.target.checked,
                  })
                }
              />
            }
            label="Parking"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={state.cctvValue}
                onChange={(e) =>
                  dispatch({
                    type: "catchCctvChange",
                    cctvChosen: e.target.checked,
                  })
                }
              />
            }
            label="CCTV"
          />

          <Button
            type="submit"
            variant="contained"
            style={{ marginBottom: '0.5rem' }}
            color="primary"
            fullWidth
          >
          Update
          </Button>
        </form>
      </Container>
    </>
  );
}

export default ListingUpdate;